import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `DefinedNameDirective` represent a defined name of the React Spreadsheet.
 * It must be contained in a Spreadsheet component(`SpreadsheetComponent`).
 * ```tsx
 * <SpreadsheetComponent>
 *   <DefinedNamesDirective>
 *    <DefinedNameDirective></DefinedNameDirective>
 *    <DefinedNameDirective></DefinedNameDirective>
 *   </DefinedNamesDirective>
 * </SpreadsheetComponent>
 * ```
 */
export class DefinedNameDirective extends ComplexBase {
}
DefinedNameDirective.moduleName = 'definedName';
export class DefinedNamesDirective extends ComplexBase {
}
DefinedNamesDirective.propertyName = 'definedNames';
DefinedNamesDirective.moduleName = 'definedNames';
